<template>
  <div class="edit_recipe_class">
    <div class="left_class">
      <div class="left_add_class" :style="{display:disNoneOrBlock}">
        <AddRawMaterials @dispalyOnChange="dispalyOnChange"/>
      </div>
      <div class="left_content_class">
        <div class="left_menu_up_class" @click="openHandle"><a-icon class="menu_up_img_class" type="highlight" />原料管理</div>
        <div class="left_menu_down_class">
          <div class="menu_down_content_class">
            <span class="down_content_title_class">配方名称</span>
            <div class="down_content_btn_class" @click="newFormulaHandle">
              <span class="down_content_textclass">任文俊的测试配方</span>
              <a-icon class="down_content_icon_class" type="form" />
            </div>
          </div>
          <div class="menu_down_content_class">
            <span class="down_content_title_class">动物类型</span>
            <div class="down_content_btn_class" @click="newFormulaHandle">
              <span class="down_content_textclass">猪</span>
              <a-icon class="down_content_icon_class" type="form" />
            </div>
          </div>
          <div class="menu_down_content_class">
            <span class="down_content_title_class">配方模型</span>
            <div class="down_content_btn_class" @click="newFormulaHandle">
              <span class="down_content_textclass">测试配方模型</span>
              <a-icon class="down_content_icon_class" type="form" />
            </div>
          </div>
          <div class="menu_down_content_class">
            <span class="down_content_title_class">配方盘重</span>
            <div class="down_content_btn_class" @click="newFormulaHandle">
              <span class="down_content_textclass">1000KG</span>
              <a-icon class="down_content_icon_class" type="form" />
            </div>
          </div>
          <div class="menu_down_content_class">
            <span class="down_content_title_class">分析基础</span>
            <div class="down_content_btn_class" @click="newFormulaHandle">
              <span class="down_content_textclass">1.000KG</span>
              <a-icon class="down_content_icon_class" type="form" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right_class">
      <div class="right_up_class">
        <div class="up_price_class">
          <span class="price_text_class">初始价格(元/吨)</span>
          <span class="price_num_class">0.0000</span>
        </div>
        <a-divider type="vertical" class="price_line_class"/>
        <div class="up_price_class">
          <span class="price_text_class">初始价格(元/吨)</span>
          <span class="price_num_class">0.0000</span>
        </div>
      </div>
      <div class="right_middle_class">
        <div class="table_left_class">
          <div class="table_left_search_class">
            <div class="table_left_search_btn_class">
              <a-button type="primary" size="default" @click="addHandle" class="add_class">
                添加
              </a-button>
              <a-button type="danger" ghost size="default" @click="resetHandle('remove')" class="remove_class">
                移出
              </a-button>
              <a-button type="default" size="default" @click="resetHandle" class="add_class">
                重置
              </a-button>
            </div>
            <div class="table_left_search_select_class">
              <div class="title_text_class">
                <SelectCascaderView :placeholderValue="placeholderValue"/>
                
              </div>
              <div class="title_text_class">
                <SelectCascaderView :placeholderValue="placeholderAllValue"/>
              </div>
            </div>
          </div>
          <div>
            <a-table
              :row-selection="{selectedRowKeys, onChange: onSelectChange}"
              :columns="columns"
              :data-source="list"
              :pagination="false"
            >
              <div slot="four" slot-scope="text">
                <a-input-number>{{text}}</a-input-number>
              </div>
            </a-table>
          </div>

        </div>
        <div class="table_right_class">
          <div class="table_right_btn_class">
            <a-button type="primary" ghost size="default" @click="checkedHandle" class="add_class">
              选择营养指标
            </a-button>
            <a-button type="default" size="default" @click="resetHandle" class="add_class">
              重置
            </a-button>
          </div>
          <div>
            <a-table
              :row-selection="{indexSelectedRowKeys, onChange: onSelectIndexChange}"
              :columns="indexColumns"
              :data-source="list"
              :pagination="false"
            >
              <div slot="four" slot-scope="text">
                <a-input-number>{{text}}</a-input-number>
              </div>
            </a-table>
          </div>
        </div>
      </div>
      <div class="right_down_class">
        <span class="right_down_text_class one_class">养分控制</span>
        <span class="right_down_text_class two_class">线性优化</span>
        <span class="right_down_text_class three_class">保 存</span>
        <span class="right_down_text_class four_class">查看报表</span>
      </div>
    </div>
    <a-modal v-model="visible" title="选择营养指标" ok-text="确定" cancel-text="取消" width="60%">
      <ChoiceNutritionModal/>
    </a-modal>
    
    <a-modal v-model="newVisible" title="新建配方" ok-text="确定" cancel-text="取消" width="60%">
      <NewFormulaModal :noneOrblock="noneOrblock"/>
    </a-modal>
  </div>
</template>
<script>

const columns = [
  {
    title: '原料名称',
    dataIndex: 'one',
  },
  {
    title: '代码',
    dataIndex: 'two',
  },
  {
    title: '用量(%)',
    dataIndex: 'three',
  },
  {
    title: '最小值',
    dataIndex: 'four',
    scopedSlots: { customRender: 'four' }
  },
  {
    title: '最大值',
    dataIndex: 'five',
  },
  {
    title: '极下限',
    dataIndex: 'six',
  },
];
const indexColumns = [
  {
    title: '指标名称',
    dataIndex: 'one',
  },
  {
    title: '数值',
    dataIndex: 'two',
  },
  {
    title: '最小值',
    dataIndex: 'four',
    scopedSlots: { customRender: 'four' }
  },
  {
    title: '最大值',
    dataIndex: 'five',
  },
];


import ChoiceNutritionModal from './SelectNutritionIndex/ChoiceNutritionModal';
import NewFormulaModal from './SelectNutritionIndex/NewFormulaModal';
import AddRawMaterials from './SelectNutritionIndex/AddRawMaterials';
import SelectCascaderView from './SelectNutritionIndex/SelectCascaderView';
export default {
  components: {
    ChoiceNutritionModal,
    NewFormulaModal,
    AddRawMaterials,
    SelectCascaderView
  },
  data(){
    return {
      placeholderValue: '合同价',
      placeholderAllValue: '所有原料',
      disNoneOrBlock: "block",
      newVisible: false,
      noneOrBlock: 'none',
      list: [{},{}],
      selectedRowKeys: [],
      columns,
      indexColumns,
      // choiceColumns,
      // choiceSelectedRowKeys: [],
      visible: false,
      indexSelectedRowKeys: [],
      
      tableSeeVisible: false,
      animalTypeRowKeys: [],
      nutrientSelectionSelectedRowKeys: []
    }
  },
  methods: {
    dispalyOnChange(){
      this.disNoneOrBlock = 'none';
    },
    
    openHandle(){
      this.disNoneOrBlock = 'inline-block';
    },
    
    onSelectChange(){},
    checkedHandle(){
      this.visible = true;
    },
    addHandle(){
      this.disNoneOrBlock = 'inline-block';
    },
    resetHandle(e){
      if (e=='remove') {
        console.log(e)
      }
      this.$confirm({
        title: '提示',
        content: '确认将选中的配方删除吗？',
        cancelText:'取消',
        okText:'确定',
        onOk() {
          console.log('删除成功。')
        },
        onCancel() {
          console.log('取消删除。')
        },
      });
    },
    onSelectIndexChange(){},
    newFormulaHandle(){
      this.newVisible = true;
    },
  }
  
}
</script>
<style lang="scss" scoped>
  .edit_recipe_class {
    display: flex;
    height: 100%;
    background-color: #f0f2f5;
    position: relative;
    .left_class {
      
      background-color: #011528;
      position: relative;
      overflow: hidden;
      color: #fff;
      .left_add_class {
        display: flex;
        flex-direction: column;
        background-color: #fff;
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        color: #011528;
        padding: 20px;
        .left_menu_up_class {
          align-items: center;
          text-align: center;
          font-weight: 700;
          position: relative;
          .menu_up_img_class {
            position: absolute;
            right: 0;
            top: 3px;
          }
        }
        .line_class {
          margin: 12px 0;
        }
      }
      .left_content_class {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        padding: 20px;
        .left_menu_up_class {
          .menu_up_img_class {
            margin-right: 10px;
          }
        }
        
        .left_menu_down_class {
          .menu_down_content_class {
            margin-bottom: 10px;
            font-size: 14px;
            font-weight: 700;
            .down_content_title_class {

            }
            .down_content_btn_class {
              .down_content_textclass {
                margin-right: 10px;
              }
              .down_content_icon_class {

              }
            }
          }
        }
      }
      
    }
    .right_class {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      padding: 10px;
      align-items: center;
      flex: 7;
      .right_up_class {
        display: flex;
        background-color: #fff;
        border-radius: 5px;
        margin-bottom: 10px;
        height: 80px;
        align-items: center;
        justify-content: space-around;
        width: 100%;
        .up_price_class {
          display: flex;
          flex-direction: column;
          align-items: center; 
          .price_text_class {

          }
          .price_num_class {
            font-size: 16px;
            font-weight: 700;
          }
        }
        .price_line_class {
          height: 40px;
        }
      }
      .right_middle_class {
        background-color: #fff;
        height: 100%;
        width: 100%;
        margin-bottom: 10px;
        border-radius: 5px;
        display: flex;
        .table_left_class {
          flex: 2;
          border-right: 1px solid #ccc;
          padding: 10px 0 10px 10px;
          .table_left_search_class {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
            .table_left_search_btn_class {
              display: flex;
              .add_class {
                margin-right: 10px;
              }
              .remove_class {
                margin-right: 10px;

              }
            }
            .table_left_search_select_class {
              display: flex;
            }
          }
        }
        .table_right_class {
          flex: 1;
          padding: 10px 10px 10px 0;
          .table_right_btn_class {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;

          }
        }
      }
      .right_down_class {
        .right_down_text_class {
          color: #fff;
          width: 80px;
          height: 26px;
          display: inline-block;
          line-height: 26px;
          text-align: center;
          font-weight: 700;
        }
        .one_class {
          background-color: #149817;
        }
        .two_class {
          background-color: #2593fc;
          
        }
        .three_class {
          background-color: #fd7945;

        }
        .four_class {
          background-color: #0c26af;

        }
      }
    }
  }
</style>